import { Grid, Typography } from '@mui/material';
import { SarlaftSurveyProps } from './props';
import { useSarlaftSurvey } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const SarlaftSurvey = (props: SarlaftSurveyProps) => {
    const { formik } = useSarlaftSurvey(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Encuesta Sarlaft
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Por su cargo o actividad ejerce algún grado de poder público?"
                    checked={Boolean(formik.values.wieldsPoliticalPower)}
                    onChange={() => {
                        formik.setFieldValue(
                            'wieldsPoliticalPower',
                            !formik.values.wieldsPoliticalPower
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.wieldsPoliticalPower}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Por su actividad u oficio goza usted de reconocimiento público general?"
                    checked={Boolean(formik.values.generalPublicRecognition)}
                    onChange={() => {
                        formik.setFieldValue(
                            'generalPublicRecognition',
                            !formik.values.generalPublicRecognition
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.generalPublicRecognition}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Es usted sujeto de obligaciones tributarias en otro país o grupo de paises?"
                    checked={Boolean(formik.values.taxesOtherCountries)}
                    onChange={() => {
                        formik.setFieldValue(
                            'taxesOtherCountries',
                            !formik.values.taxesOtherCountries
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.taxesOtherCountries}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Existe algún vinculo entre usted y una persona considerada públicamente expuesta?"
                    checked={Boolean(formik.values.publiclyExposedPerson)}
                    onChange={() => {
                        formik.setFieldValue(
                            'publiclyExposedPerson',
                            !formik.values.publiclyExposedPerson
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.publiclyExposedPerson}
                />
            </Grid>
            {formik.values.publiclyExposedPerson && (
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="¿Cuál?"
                        name="which"
                        size="small"
                        onBlur={formik.handleBlur}
                        touched={formik.touched.which}
                        errors={formik.errors.which}
                        value={formik.values.which}
                        onChange={formik.handleChange}
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="¿Por su cargo o actividad maneja recursos públicos?"
                    checked={Boolean(formik.values.managesPublicResources)}
                    onChange={() => {
                        formik.setFieldValue(
                            'managesPublicResources',
                            !formik.values.managesPublicResources
                        );
                    }}
                    onBlur={formik.handleBlur}
                    errors={formik.errors.managesPublicResources}
                />
            </Grid>
        </Grid>
    );
};
